module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAPPz8/+KKP+GKf+HKP+FKf+EKYaGhmk9ADUkADUcED0YDCAcABQcAFEEBBwQCCQMABQQAD0AADEAAC0AAAgICCQAABwAABQABAwAAAQAAP///wAAAAAAAAAAAAAAAAAAACH5BAEHABoALAAAAAAgACAAAAW6oCaOpJadaJoBZeuaWSHP8/neYkzvxZHhLh1v9wOWhMOa8VhTnWTFZa6QiVScz6g0prpYUlTpKIvlapeoJNUmhmHUmcnZeLLAr22YA84WP9VreX98ghkMcBFzQCcLcHJiBnpwXxqRRgYGGRJIRCeYUplvgJ5tWQgPEAkKChcVgaVrZXaKODoZXykTorQ3SBMNDRMTNLwvnEnFQYBKsMthzcvJLVEDPGN5GhQiAdzdATnYItpDJuFjZUAhADs="


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadS_S5.gif
// module id = Pk59
// module chunks = 48